import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TotalTravauxComponent} from './total-travaux/total-travaux.component';
import {CashFlowComponent} from './cash-flow/cash-flow.component';
import {RendementBrutComponent} from './rendement-brut/rendement-brut.component';
import {RendementNetComponent} from './rendement-net/rendement-net.component';
import {TauxEtudiantComponent} from './taux-etudiant/taux-etudiant.component';
import {TauxChomageComponent} from './taux-chomage/taux-chomage.component';
import {KpiDirective} from './kpi.directive';
import { MensualiteComponent } from './mensualite/mensualite.component';
import { NiveauVieComponent } from './niveau-vie/niveau-vie.component';
import { TauxLogementVacantComponent } from './taux-logement-vacant/taux-logement-vacant.component';
import { TauxProprietaireComponent } from './taux-proprietaire/taux-proprietaire.component';
import { TauxLocataireComponent } from './taux-locataire/taux-locataire.component';
import { HabitantComponent } from './habitant/habitant.component';
import { TotalSortieComponent } from './total-sortie/total-sortie.component';
import { TotalPriceComponent } from './total-price/total-price.component';
import { SquareComponent } from './square/square.component';
import { SquarePriceComponent } from './square-price/square-price.component';
import { SquarePriceDiffComponent } from './square-price-diff/square-price-diff.component';
import { PartTravauxComponent } from './part-travaux/part-travaux.component';
import { TotalLoyerComponent } from './total-loyer/total-loyer.component';
import { FirstDateComponent } from './first-date/first-date.component';
import { SquareRentComponent } from './square-rent/square-rent.component';
import { SquareWorkComponent } from './square-work/square-work.component';
import { CitySquarePriceComponent } from './city-square-price/city-square-price.component';
import { CityEfficiencyComponent } from './city-efficiency/city-efficiency.component';
import { SimulatorComponent } from './simulator/simulator.component';
import { ChangeCityComponent } from './change-city/change-city.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { FiscaMobileComponent } from './fisca-mobile/fisca-mobile.component';
import { PriceComponent } from './price/price.component';
import { PriceCityEvolComponent } from './price-city-evol/price-city-evol.component';
import { TensionLocativeComponent } from './tension-locative/tension-locative.component';


@NgModule({
    declarations: [
        KpiDirective,
        TotalTravauxComponent,
        CashFlowComponent,
        RendementBrutComponent,
        RendementNetComponent,
        TauxEtudiantComponent,
        TauxChomageComponent,
        MensualiteComponent,
        NiveauVieComponent,
        TauxLogementVacantComponent,
        TauxProprietaireComponent,
        TauxLocataireComponent,
        HabitantComponent,
        TotalSortieComponent,
        TotalPriceComponent,
        SquareComponent,
        SquarePriceComponent,
        SquarePriceDiffComponent,
        PartTravauxComponent,
        TotalLoyerComponent,
        FirstDateComponent,
        SquareRentComponent,
        SquareWorkComponent,
        CitySquarePriceComponent,
        CityEfficiencyComponent,
        SimulatorComponent,
        ChangeCityComponent,
        FiscaMobileComponent,
        PriceComponent,
        PriceCityEvolComponent,
        TensionLocativeComponent,
    ],
    exports: [
        KpiDirective,
        TotalTravauxComponent,
        CashFlowComponent,
        RendementBrutComponent,
        RendementNetComponent,
        TauxEtudiantComponent,
        TauxChomageComponent,
        MensualiteComponent,
        NiveauVieComponent,
        TauxLogementVacantComponent,
        TauxProprietaireComponent,
        TauxLocataireComponent,
        HabitantComponent,
        TotalSortieComponent,
        TotalPriceComponent,
        SquareComponent,
        SquarePriceComponent,
        SquarePriceDiffComponent,
        PartTravauxComponent,
        TotalLoyerComponent,
        FirstDateComponent,
        SquareRentComponent,
        SquareWorkComponent,
        CitySquarePriceComponent,
        CityEfficiencyComponent,
        SimulatorComponent,
        ChangeCityComponent,
        FiscaMobileComponent,
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
    ]
})
export class KpiModule {
}
